import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import axios from '../../api/axios';
import AdminLayout from '../../layouts/AdminLayout';
import { toast } from 'react-toastify';

const Profile = () => {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        username: '',
        email: '',
        company_name: '',
        phone: '',
        tax_number: '',
        tax_office: '',
        address: '',
        country: '',
        city: '',
        postal_code: '',
        password: ''
    });

    useEffect(() => {
        const fetchProfile = async () => {
            try {
                const res = await axios.get('/users/profile');
                setFormData(prev => ({
                    ...prev,
                    username: res.data.username,
                    email: res.data.email,
                    company_name: res.data.company_name || '',
                    phone: res.data.phone || '',
                    tax_number: res.data.tax_number || '',
                    tax_office: res.data.tax_office || '',
                    address: res.data.address || '',
                    country: res.data.country || '',
                    city: res.data.city || '',
                    postal_code: res.data.postal_code || ''
                }));
            } catch (error) {
                console.error('Profil yüklenemedi');
            }
        };
        fetchProfile();
    }, []);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await axios.put('/users/profile', {
                company_name: formData.company_name,
                phone: formData.phone,
                password: formData.password || undefined
            });
            toast.success(t('messages.password_updated'));
            setFormData(prev => ({ ...prev, password: '' }));
        } catch (error) {
            toast.error(t('messages.update_failed'));
        }
    };

    return (
        <AdminLayout>
            <h2>{t('profile.title')}</h2>
            <div className="card shadow-sm mt-3" style={{ maxWidth: '800px' }}>
                <div className="card-body">
                    <form onSubmit={handleSubmit}>
                        <h5 className="text-primary border-bottom pb-2 mb-3">{t('profile.company_info')}</h5>
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <label className="form-label fw-bold small text-muted">{t('profile.company_name')}</label>
                                <input type="text" className="form-control bg-light" value={formData.company_name} disabled />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label fw-bold small text-muted">{t('profile.authorized_person')}</label>
                                <input type="text" className="form-control bg-light" value={formData.username} disabled />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <label className="form-label fw-bold small text-muted">{t('profile.email')}</label>
                                <input type="email" className="form-control bg-light" value={formData.email} disabled />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label fw-bold small text-muted">{t('profile.phone')}</label>
                                <input type="text" className="form-control bg-light" value={formData.phone} disabled />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <label className="form-label fw-bold small text-muted">{t('profile.tax_number')}</label>
                                <input type="text" className="form-control bg-light" value={formData.tax_number} disabled />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label fw-bold small text-muted">{t('profile.tax_office')}</label>
                                <input type="text" className="form-control bg-light" value={formData.tax_office} disabled />
                            </div>
                        </div>

                        <h5 className="text-primary border-bottom pb-2 mb-3 mt-4">{t('profile.address_info')}</h5>
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <label className="form-label fw-bold small text-muted">{t('profile.country')}</label>
                                <input type="text" className="form-control bg-light" value={formData.country} disabled />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label fw-bold small text-muted">{t('profile.city')}</label>
                                <input type="text" className="form-control bg-light" value={formData.city} disabled />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-md-4">
                                <label className="form-label fw-bold small text-muted">{t('profile.postal_code')}</label>
                                <input type="text" className="form-control bg-light" value={formData.postal_code} disabled />
                            </div>
                            <div className="col-md-8">
                                <label className="form-label fw-bold small text-muted">{t('profile.address')}</label>
                                <input type="text" className="form-control bg-light" value={formData.address} disabled />
                            </div>
                        </div>

                        <h5 className="text-primary border-bottom pb-2 mb-3 mt-4">{t('profile.security')}</h5>
                        <div className="mb-3">
                            <label className="form-label fw-bold small text-muted">{t('profile.new_password')}</label>
                            <input 
                                type="password" 
                                className="form-control" 
                                name="password"
                                value={formData.password} 
                                onChange={handleChange} 
                                placeholder={t('profile.password_placeholder')}
                            />
                        </div>
                        <div className="text-end">
                            <button type="submit" className="btn btn-primary px-4">{t('profile.update_password')}</button>
                        </div>
                    </form>
                </div>
            </div>
        </AdminLayout>
    );
};

export default Profile;